import { render } from "./BatchRegister.vue?vue&type=template&id=48c9c9ad&scoped=true"
import script from "./BatchRegister.vue?vue&type=script&lang=js"
export * from "./BatchRegister.vue?vue&type=script&lang=js"

import "./BatchRegister.vue?vue&type=style&index=0&id=48c9c9ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c9c9ad"]])

export default __exports__